import React, { useEffect, useMemo, useState } from 'react';
import Typography from '@material-ui/core/Typography';

import './style.scss'
import { useDispatch, useSelector } from 'react-redux';
// import DatePicker from '../../../../../../components/Inputs/DatePicker/DatePicker';
// import TimePicker from '../../../../../../components/Inputs/TimePicker/TimePicker';
import SearchBox from '../../../../../../components/SearchBox/SearchBox';
import Version from './Version';
import { useParams } from 'react-router-dom';
import AccessPoint from './AccessPoint';
// import moment from 'moment-timezone';
import { doGetVersions, doUpdateVersion } from '../../../../../../redux/thunks/readers';
import { selectCurrentPartner } from '../../../../../../redux/selectors/authentication';
import { doReadOrganisationAccessPoints } from '../../../../../../redux/thunks/organisation';
import { convertToHex } from '../../../../../../helpers/renderers';
import SDialog from '../../../../../../components/SDialog/SDialog';
import FlexColumn from '../../../../../../components/FlexBox/FlexColumn';
import Divider from '../../../../../../components/Divider/Divider';

const UpdateFirmware = ({ open, onClose, readerDetails = {}, selectedReaders = [], bulkUpdate = false }) => {

    const dispatch = useDispatch();

    const { customerId } = useParams();
    const { currentUser } = useSelector((state) => ({
        currentUser: selectCurrentPartner(state),
    }));

    const [versions, setVersions] = useState([])

    // const [selectedDate, setSelectedDate] = useState(null);
    // const [selectedTime, setSelectedTime] = useState(null);
    const [selectedVersion, setSelectedVersion] = useState(0);
    const [readersToUpdate, setReadersToUpdate] = useState([]);

    const [search, setSearch] = useState('');

    useEffect(() => {
        if (open) {
            setReadersToUpdate(selectedReaders);
        }
    }, [open, selectedReaders])

    useEffect(() => {
        if (!bulkUpdate && open) {
            const payload = { pdSwId: readerDetails?.pdSwId, serialNumber: readerDetails?.serialNumber }
            dispatch(doGetVersions(payload, (allVers) => { setVersions(allVers?.map(v => ({ ...v, version: convertToHex(v?.pdSwVer) }))) }))
        }
    }, [open, bulkUpdate, readerDetails, selectedReaders, dispatch])

    const popupToggle = () => {
        onClose();
    };

    const hSearch = (e) => {
        const { value } = e?.target;
        setSearch(value?.trimStart());
    }

    const hUpdate = () => {
        // const combinedDateTime = moment(selectedTime)
        //     .year(moment(selectedDate).year())
        //     .month(moment(selectedDate).month())
        //     .date(moment(selectedDate).date());
        const payload = {
            serialNumbers: bulkUpdate ? readersToUpdate?.map(r => r.serialNumber) : [readerDetails?.serialNumber],
            // scheduleTime: combinedDateTime.valueOf(),
        }
        if (!bulkUpdate) {
            payload["updateToPdSwVer"] = selectedVersion
        }

        dispatch(doUpdateVersion(payload, customerId, () => {
            dispatch(
                doReadOrganisationAccessPoints({
                    partnerId: currentUser.partnerId,
                    organisationId: customerId,
                    displayNotification: false,
                }),
            );
            popupToggle();
        }))
    }

    const hVersionChange = (ver) => {
        setSelectedVersion(ver);
    }

    const hRemoveReader = (readerId) => {
        setReadersToUpdate(readersToUpdate?.filter(sr => sr?.id !== readerId) || [])
    }

    const filteredAccessPointList = useMemo(() => {
        return readersToUpdate?.filter(ap => ap?.accessPoint?.includes(search)) || []
    }, [readersToUpdate, search])

    const filteredVersionList = useMemo(() => {
        return versions?.filter(ap => ap?.version?.includes(search)) || []
    }, [versions, search]);

    const isUpdateDisabled = useMemo(() => {
        // if (!selectedDate || !selectedTime) {
        //     return true;
        // }

        if (bulkUpdate && readersToUpdate?.length <= 0) {
            return true
        } else if (!bulkUpdate && !selectedVersion) {
            return true
        }

        return false
    }, [selectedVersion, readersToUpdate, bulkUpdate])

    return (
        <SDialog
            title='Update Firmware Version'
            description='During the firmware update, the device will go offline. This may take several hours.'
            descriptionConfig={{
                color: 'var(--warn-500)'
            }}
            open={open}
            onClose={popupToggle}
            secondaryButtonConfig={{
                text: 'Cancel',
                onClick: popupToggle
            }}
            primaryButtonConfig={{
                text: 'Update',
                onClick: hUpdate,
                disabled: isUpdateDisabled
            }}
            isFormDialog={true}
        >
            <FlexColumn alignItems='start'>
                <FlexColumn gap='0' alignItems='start'>
                    {bulkUpdate && <Typography variant="body1" style={{ fontSize: '0.875rem' }} >Bulk update installs the latest firmware on all selected access points. To choose specific versions, update each device individually.</Typography>}
                    <Typography variant='h7' style={{ fontSize: '1rem', color: '#656B70', marginTop: '0.5rem' }}>Schedule Update</Typography>
                    <Typography variant='h7' style={{ fontSize: '1rem', color: '#373A3D', fontWeight: '400' }}><span style={{ color: '#353F94', fontWeight: '600' }}>NOTE:</span> Firmware updates will run based on the reader’s timezone,</Typography>
                    <Divider />
                </FlexColumn>
                {/* <div className='row-container' style={{ gap: '2rem', marginBottom: '1rem' }}>
                    <DatePicker
                        disablePast
                        label="Date"
                        value={selectedDate}
                        onChange={(val) => { setSelectedDate(val) }}
                    />
                    <TimePicker
                        label={"Time"}
                        value={selectedTime}
                        onChange={(val) => { setSelectedTime(val?.target?.value) }}
                    />
                </div> */}
                <SearchBox onChange={hSearch} value={search} />
                {bulkUpdate ?
                    <FlexColumn gap='0'>
                        <div className='ap-container' style={{ padding: '0.5rem 1rem', marginTop: '1rem', width: '100%' }}>
                            <Typography variant='h7' className='ap-title'>Access Points</Typography>
                            <Typography variant='body1' className='ap-count'>{readersToUpdate?.length || '0'} Selected</Typography>
                        </div>
                        <div className='scroll-container' style={{ width: '100%' }}>
                            {filteredAccessPointList?.map(sr => (
                                <AccessPoint readerDetails={sr} onRemove={hRemoveReader} />
                            ))}
                        </div>
                    </FlexColumn> :
                    <div className='scroll-container' style={{ width: '100%' }}>
                        {filteredVersionList?.map(ver => (
                            <Version selected={selectedVersion === ver?.pdSwVer} version={ver?.pdSwVer} currentVersion={readerDetails?.firmwareVersion === ver?.pdSwVer} onChange={hVersionChange} />
                        ))}
                    </div>}
            </FlexColumn>
        </SDialog>
    );
};

export default UpdateFirmware;
